import { SummaryCard } from '../../../types';

export const inkilapCards: SummaryCard[] = [];